import { DATASET_LNG } from '_legacy/models/Datasets';

const sparkRateIndices = [
    {
        value: 'Spark30s',
        label: 'Spark30s',
        datasetIds: [DATASET_LNG],
    },
    {
        value: 'Spark25',
        label: 'Spark25',
        datasetIds: [DATASET_LNG],
    },
];

const sparkRateIndicesWithId = sparkRateIndices.map((value, index) => {
    return { ...value, id: index + 1 };
});

export const getSparkRateIndicesByDatasetId = (datasetId) => {
    return sparkRateIndicesWithId.filter((index) =>
        index.datasetIds.includes(datasetId)
    );
};

export const getSparkIndexByValue = (value) => {
    return sparkRateIndicesWithId.find((index) => index.value === value);
};
